import * as common from '../common.js'
import http from '../http.request'

const couponMixin = {
    computed: {
        normalCoupons() {
            return (this.coupons || []).filter(coupon => coupon.displayType === 'normal'
                    && this.checkCouponAvailable(coupon));
        },
        otherCoupons() {
            return (this.coupons || []).filter(coupon => coupon.displayType === 'other'
                    && this.checkCouponAvailable(coupon));
        }
    },
    methods: {
        $t: window.$t,
        checkCouponAvailable(coupon) {
            return !coupon.useAmountLimitExceeded && !coupon.useQuantityLimitExceeded && !coupon.usePeriodExceeded;
        },
    }
}

const couponModalReadMore = {
    data() {
        return {
            readMoreToggled: false
        }
    },
    methods: {
        readMore(toggled) {
            this.readMoreToggled = toggled;
        }
    },
    template: `
        <div>
            <p class="moreClose">
                <a href="#" v-on:click.prevent="readMore(false)"
                   v-if="readMoreToggled">{{ $t("coupon.label.close") }}</a>
                <a href="#" v-on:click.prevent="readMore(true)"
                   v-if="!readMoreToggled">{{ $t("coupon.label.more") }}</a>
            </p>
            <div v-if="readMoreToggled">
                <slot></slot>
            </div>
        </div>
        `
}

const couponModalPlan = {
    props: {
        coupon: Object
    },
    template: `
        <div class="plans" v-if="coupon.targetPlans.length">
            <h4>{{ $t("coupon.label.targetPlans") }}</h4>
            <ul>
                <li v-for="plan in coupon.targetPlans">
                    {{ plan.name }}
                </li>
            </ul>
        </div>
        `
}

const couponModalItem = {
    mixins: [couponMixin],
    props: {
        coupons: {
            type: Array,
            default: () => []
        },
        showAction: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            errorMap: {},
            acquiredMap: {}
        }
    },
    components: {
        couponModalReadMore,
        couponModalPlan
    },
    methods: {
        async gettingCoupon(coupon) {
            this.errorMap = Object.assign({}, this.errorMap, {})
            const currentUrl = new URL(window.location.href);
            const params = currentUrl.search;

            const url = `${window.$contextPath}${window.$contextPath.endsWith('/') ? '' : '/'}api/coupons/acquire/${coupon.id}${params}`;

            this.$set(this.errorMap, coupon.id, null);

            const response = await http.get(url);
            const res = JSON.parse(response);
            if(res.result) {
                this.$set(this.acquiredMap, coupon.id, true);
                if(this.$root && this.$root.searchStayPlan) {
                    this.$root.searchStayPlan();
                }
            }else {
                this.$set(this.errorMap, coupon.id, res.errorMessage);
            }
        }
    },
    template: `
        <div v-if="coupons?.length">
            <div class="itemContainer" v-for="coupon in coupons" :key="coupon">
                <div class="item">
                    <div class="aside">
                        <div v-if="coupon.discountAmount > 0">
                            {{ $t("coupon.label.discountAmount.upper", {context: '' + coupon.fromTotalBookings}) }}<br>
                            <strong>{{ $t("coupon.label.discountAmount", {amount: coupon.discountAmount, context: coupon.discountType}) }}</strong>
                        </div>
                        <div v-else>
                            <strong>{{ $t("coupon.label.discountAmount.has.zeroDiscount") }}</strong>
                        </div>
                    </div>
                    <div class="article">
                        <div class="couponName">
                            <h5>{{coupon.name}}</h5>
                            <span class="pl10" v-if="coupon.type === 'code'">{{ $t("coupon.label.code", {code: coupon.code}) }}</span>
                        </div>
                        <dl class="flex" v-if="coupon.type == 'acquire'">
                            <dt>{{ $t("coupon.label.expiredAt") }}</dt>
                            <dd v-if="coupon.availableMonths && coupon.acquireDate && coupon.expiredAt?.end">
                                {{ $t("coupon.label.periodRange", {day: coupon.expiredAt}) }}
                            </dd>
                            <dd v-else-if="coupon.availableMonths && !coupon.acquireDate">
                                {{ $t("coupon.label.availableMonths", {months: coupon.availableMonths}) }}
                            </dd>
                            <dd v-else-if="coupon.expiredAt?.end">
                                {{ $t("coupon.label.periodRange", {day: coupon.expiredAt}) }}
                            </dd>
                            <dd v-else>
                                {{ $t("coupon.label.neverExpires") }}
                            </dd>
                        </dl>
                        <dl class="flex" v-if="coupon.stayAt">
                            <dt>{{ $t("coupon.label.stayAt") }}</dt>
                            <dd>{{ $t("coupon.label.periodRangeCheck", {day: coupon.stayAt}) }}</dd>
                        </dl>
                        <dl class="flex" v-if="coupon.unavailableDays.length">
                            <dt>{{ $t("coupon.label.unavailableDays") }}</dt>
                            <dd>
                                <span v-for="(day, index) in coupon.unavailableDays">
                                    <label v-if="index > 0">・</label>{{ $t("common.calendar." + day + ".short") }}
                                </span>
                            </dd>
                        </dl>
                        <dl class="flex unavailablePeriod" v-if="coupon.unavailablePeriod.length">
                            <dt>{{ $t("coupon.label.unavailablePeriod") }}</dt>
                            <dd>
                                <span v-for="(period, index) in coupon.unavailablePeriod">
                                    <label v-if="index > 0">、</label>{{ $t("coupon.label.periodRange", {day: period}) }}
                                </span>
                            </dd>
                        </dl>

                        <p style="margin-top: 16px;" v-if="coupon.discountAmount > 0 && !coupon.fromTotalBookings">{{ $t("coupon.label.fromTotalBookings.not") }}</p>

                        <coupon-modal-read-more v-bind:coupon="coupon">
                            <p class="couponDescription">{{coupon.description}}</p>

                            <ul class="boxWrap">
                                <li class="border" v-if="coupon.discountLimit && coupon.discountType === 'rate'">{{ $t("coupon.label.discountLimit", {amount: coupon.discountLimit, context: coupon.rateType}) }}</li>
                                <li class="border">{{ $t("coupon.label.canUseTogether", {context: '' + coupon.canUseTogether}) }}</li>
                                <li class="border" v-if="coupon.useQuantityLimit > 0">{{ $t("coupon.label.useQuantityLimit", {amount: coupon.useQuantityLimit}) }}</li>
                                <li class="border">{{ $t("coupon.label.useCondition", {amount: coupon.useCondition})}}</li>
                                <li class="border" v-if="coupon.useTimesLimit === 1">{{ $t("coupon.label.remainingTimes.one", {amount: coupon.useTimesLimit})}}</li>
                                <li class="border" v-else-if="coupon.useTimesLimit > 1">{{ $t("coupon.label.remainingTimes", {amount: coupon.useTimesLimit, remains: coupon.remainingTimes})}}</li>
                                <li class="border" v-else>{{ $t("coupon.label.remainingTimes.noLimit")}}</li>
                            </ul>

                            <coupon-modal-plan v-bind:coupon="coupon"></coupon-modal-plan>
                        </coupon-modal-read-more>
                    </div>
                    <div class="acquire" v-if="showAction && !errorMap[coupon.id]">
                        <p class="couponAcquired" v-if="coupon.acquireDate || acquiredMap[coupon.id]">{{ $t("coupon.label.acquired") }}</p>
                        <p v-else>
                            <a class="buttonType01 primary_button" v-on:click="gettingCoupon(coupon)">{{ $t("coupon.label.acquiring") }}</a>
                        </p>
                    </div>
                </div>
                <ul class="importantMessage" v-if="errorMap[coupon.id]">
                    <li><span>{{ errorMap[coupon.id] }}</span></li>
                </ul>
            </div>
        </div>
    `
}
const couponBadgeModal = {
    mixins: [couponMixin],
    props: {
        modalId: {
            type: String,
            default: 'coupon_badge_banner'
        },
        coupons: {
            type: Array,
            default: () => []
        }
    },
    components: {
        couponModalItem: couponModalItem
    },
    template: `
        <div class="modalWindow couponModal" v-bind:id="modalId" v-if="coupons?.length">
            <div class="close"><span class="closeArea">×</span></div>
            <h3>{{ $t("coupon.modal.title.member") }}</h3>
            <div>{{ $t("coupon.modal.caution") }}</div>

            <coupon-modal-item v-bind:coupons="normalCoupons" v-bind:showAction="true"></coupon-modal-item>

            <div v-if="otherCoupons.length">
                <h4>{{ $t("coupon.modal.has.otherCoupons") }}</h4>
                <coupon-modal-item v-bind:coupons="otherCoupons" v-bind:showAction="true"></coupon-modal-item>
            </div>

            <div class="caution">
                <ul>
                    <li v-for="n in 4">{{ $t("coupon.modal.desc." + n) }}</li>
                </ul>
            </div>
        </div>
        `
}

const couponBadge = {
    mixins: [couponMixin],
    props: {
        coupons: {
            type: Array,
            default: () => []
        }
    },
    template: `
        <span class="couponBadge" v-if="coupons?.length">
        {{ $t("coupon.badge.couponTarget") }}
        </span>
        `
}

const couponBadgeBanner = {
    props: {
        modalId: {
            type: String,
            default: 'coupon_badge_banner'
        },
        bannerType: String,
        coupons: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        $t: window.$t,
        initializeJQueryEvents: function () {
            common.modalEvents(this.$el);
        }
    },
    updated: function () {
        this.$nextTick(() => {
            this.$nextTick(() => {
                this.initializeJQueryEvents();
            });
        });
    },
    mounted: function () {
        this.$nextTick(() => {
            this.initializeJQueryEvents();
        });
    },
    template: `
        <div class="couponBadgeBanner" v-if="coupons?.length && bannerType === 'badge'">
            <a href="#" class="modalLink text_gold"
                v-bind:data-target="modalId">
                {{ $t("coupon.badge.banner.title") }}
            </a>
        </div>
        `
}

const couponBannerMembership = {
    props: {
        hotelCode: String
    },
    methods: {
        $t: window.$t
    },
    template: `
        <div class="membership">
            <div class="coupon_registration">
                <form method="GET" v-bind:action="$contextPath + 'guest-reserve-front/sso/register'">
                    <a class="buttonType01 primary_button" onclick="memberAuthAction(arguments[0])">{{ $t("coupon.modal.memberRegister") }}</a>
                    <input type="hidden" name="hotelCode" v-bind:value="hotelCode">
                    <input type="hidden" name="return_url" value="">
                    <input type="hidden" name="ui_locales" v-bind:value="$currentLanguage">
                </form>
            </div>
            <div class="coupon_login">
                <p>{{ $t("coupon.modal.membership") }}</p>
                <form method="GET" v-bind:action="$contextPath + 'guest-reserve-front/sso/login'">
                    <a style="cursor: pointer;" onclick="memberAuthAction(arguments[0])">{{ $t("coupon.modal.memberLogin") }}</a>
                    <input type="hidden" name="hotelCode" v-bind:value="hotelCode">
                    <input type="hidden" name="return_url" value="">
                    <input type="hidden" name="ui_locales" v-bind:value="$currentLanguage">
                </form>
            </div>
        </div>
    `
}

const couponBannerModal = {
    mixins: [couponMixin],
    props: {
        modalId: {
            type: String,
            default: 'coupon_banner'
        },
        available: Boolean,
        coupons: {
            type: Array,
            default: () => []
        },
        hotelCode: String
    },
    components: {
        couponBannerMembership: couponBannerMembership,
        couponModalItem: couponModalItem
    },
    template: `
        <div class="modalWindow couponModal" v-bind:id="modalId" v-if="available">
            <div class="close"><span class="closeArea">×</span></div>
            <h3 class="inputArea">{{ $t("coupon.modal.title") }}</h3>
            <div class="inputArea">{{ $t("coupon.modal.caution") }}</div>

            <coupon-banner-membership v-bind:hotelCode="hotelCode"></coupon-banner-membership>

            <coupon-modal-item v-bind:coupons="normalCoupons"></coupon-modal-item>

            <div v-if="otherCoupons.length">
                <h4>{{ $t("coupon.modal.has.otherCoupons") }}</h4>
                <coupon-modal-item v-bind:coupons="otherCoupons"></coupon-modal-item>
            </div>

            <div class="caution">
                <ul>
                    <li v-for="n in 4">{{ $t("coupon.modal.desc." + n) }}</li>
                </ul>
            </div>

            <coupon-banner-membership v-bind:hotelCode="hotelCode" v-if="coupons.length > 3"></coupon-banner-membership>
        </div>
        `
}

const couponBanner = {
    props: {
        modalId: {
            type: String,
            default: 'coupon_banner'
        },
        available: Boolean,
        bannerType: String,
        coupons: {
            type: Array,
            default: () => []
        },
        errorMessage: String
    },
    methods: {
        $t: window.$t,
        initializeJQueryEvents: function () {
            common.modalEvents(this.$el);
        }
    },
    updated: function () {
        this.$nextTick(() => {
            this.$nextTick(() => {
                this.initializeJQueryEvents();
            });
        });
    },
    mounted: function () {
        this.$nextTick(() => {
            this.initializeJQueryEvents();
        });
    },
    template: `
        <div class="couponArea">
            <ul class="importantMessage" v-if="errorMessage">
                <li><span>{{ errorMessage }}</span></li>
            </ul>
            <a class="modalLink" v-else-if="available && bannerType === 'banner' && coupons?.length" v-bind:data-target="modalId">
                <div class="couponBanner border_gold text_gold">
                    <div>
                        <p>
                            {{ $t("coupon.banner.title.member") }}<br>
                            <strong>{{ $t("coupon.banner.title") }}</strong>
                        </p>
                    </div>
                    <div class="buttonType01 primary_button couponBannerBtn">
                        {{ $t("coupon.banner.title.button") }}
                    </div>
                </div>
            </a>
        </div>
        `
};

export {
    couponBanner,
    couponBannerModal,
    couponBadge,
    couponBadgeModal,
    couponBadgeBanner
}
